import { InstitutionsResponseDTO } from 'models'
import InstitutionsService from 'services/institutions'
import { SESSION_KEYS } from 'utils/sessionKeys'

interface InstitutionQueryDTO {
    razaoSocial?: string
}

interface FetchInstitutionsParams {
    setInstitutions: (institutions: InstitutionsResponseDTO[]) => void
    setInstitution: (institutions: InstitutionsResponseDTO) => void
    institutionOptionAll: InstitutionsResponseDTO | null
}

export class InstitutionDomain {
    private get cachedInstitutions(): InstitutionsResponseDTO[] {
        return JSON.parse(
            sessionStorage.getItem(SESSION_KEYS.LIST_INSTITUTIONS) || '[]'
        )
    }

    private get isEmptyCachedInstitutions(): boolean {
        return this.cachedInstitutions.length === 0
    }

    private get cacheCurrentInstitution(): InstitutionsResponseDTO {
        return JSON.parse(
            sessionStorage.getItem(SESSION_KEYS.CURRENT_INSTITUTION) || '{}'
        )
    }

    private get isEmptyCurrentInstitution(): boolean {
        return Object.keys(this.cacheCurrentInstitution).length === 0
    }

    private setCacheInstitutions(institutions: InstitutionsResponseDTO[]) {
        sessionStorage.setItem(
            SESSION_KEYS.LIST_INSTITUTIONS,
            JSON.stringify(institutions)
        )
    }

    private setCacheCurrentInstitution(institution: InstitutionsResponseDTO) {
        sessionStorage.setItem(
            SESSION_KEYS.CURRENT_INSTITUTION,
            JSON.stringify(institution)
        )
    }

    public resetCache() {
        sessionStorage.removeItem(SESSION_KEYS.LIST_INSTITUTIONS)
        sessionStorage.removeItem(SESSION_KEYS.CURRENT_INSTITUTION)
    }

    public async fetchInstitutionsAutocomplete(
        query: InstitutionQueryDTO,
        {
            setInstitutions,
            setInstitution,
            institutionOptionAll
        }: FetchInstitutionsParams
    ) {
        try {
            if (query?.razaoSocial) {
                const { data: institutions } =
                    await InstitutionsService.getInstitutions(query)
                setInstitutions(institutions)

                return
            }

            const hasCache =
                !this.isEmptyCachedInstitutions &&
                !this.isEmptyCurrentInstitution

            if (hasCache) {
                setInstitutions(this.cachedInstitutions)
                setInstitution(
                    institutionOptionAll ?? this.cacheCurrentInstitution
                )

                return
            }

            const queryParams = { limite: 10 }
            const { data: institutions } =
                await InstitutionsService.getInstitutions(queryParams)

            setInstitutions(institutions)
            setInstitution(institutionOptionAll ?? institutions[0])

            this.setCacheInstitutions(institutions)
            this.setCacheCurrentInstitution(
                institutionOptionAll ?? institutions[0]
            )
        } catch (error) {
            console.error('failed to load institutions')
        }
    }
}
